<template>

    <!-- RESIDENCE INTERACTIVE -->
    <div class="residence" :class="{ zoomed: isZoomed }">
        <div id="base-container"></div>
    </div>
    <!-- END RESIDENCE INTERACTIVE -->

</template>


<script>

    import * as PIXI from 'pixi.js';
    import { pixi_display } from 'pixi-layers';
    import * as filters from 'pixi-filters';
    import { TweenMax, CSSPlugin, EasePack, TextPlugin, PixiPlugin } from 'gsap';
    import Hammer from 'hammerjs';

    let vm = {};

    export default {

        name: 'residence-interactive',

        components: {},

        data() {
            return {
                zoomed: false,
                residenceImage: '/static/images/MBR-055_House-Layered_Base_75.jpg',
                target: {
                    width: 5933,
                    height: 3671
                },
                pixiApp: null,
                container: null,
                stage: null,
                residence: null,
                pointLayer: null,
                graphicLayer: null,
                animationLayer: null,
                highlightLayer: null,
                dimLayer: null,
                scale: {
                    initial: 0.4,
                    wide: 0.25,
                    min: 0.31,
                    max: 1,
                    duration: {
                        in: 1.3,
                        out: 1.3
                    },
                    points: {
                        in: 1,
                        out: 1
                    }
                },
                zoomInOffset: {
                    x: 500,
                    y: 500
                },
                rooms: [
                    {
                        name: 'bedroom',
                        width: 939,
                        height: 530,
                        x: -730,
                        y: -92
                    }, {
                        name: 'landing',
                        width: 835,
                        height: 530,
                        x: 186,
                        y: -92
                    }, {
                        name: 'bathroom',
                        width: 832,
                        height: 530,
                        x: 1047,
                        y: -92
                    }, {
                        name: 'livingroom',
                        width: 1372,
                        height: 530,
                        x: -709,
                        y: 494
                    }, {
                        name: 'kitchen',
                        width: 969,
                        height: 530,
                        x: 489,
                        y: 494
                    }, {
                        name: 'mudroom',
                        width: 462,
                        height: 530,
                        x: 1232,
                        y: 494
                    }
                ],
                exposureObjects: {},
                exposureImageObjects: {},
                animationObjects: {},
                highlightObjects: [],
                dimmerObjects: [],
                lastInteraction: 0,
                pulseTimeline: [],
                pulseInterval: null,
                pulseTimeout: null,
                pulseIntervalDuration: 3000,
                pulseAll: true,
                pulseAnimating: false,
                pulseClicked: false
            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.getters.getEnteredState;
            },

            isZoomed() {
                return this.$dataStore.getters.getZoomedState;
            },

            pApp() {
                return this.$dataStore.getters.getInteractive;
            },

            exposures() {
                return this.$dataStore.getters.getExposures;
            },

            powerSurge() {
                return this.$dataStore.getters.getExposures;
            }

        },

        created() {
            vm = this;

            this.$eventBus.$on('residence:zoomin', vm.zoomIn);
            this.$eventBus.$on('residence:zoomout', (duration) => vm.zoomOut(duration));
            this.$eventBus.$on('residence:zoomto', (obj) => { vm.zoomTo(1, 1, 1, Quad.easeInOut, null, vm.exposureObjects[obj.slug]) });
            this.$eventBus.$on('residence:transition:in', vm.transitionIn);
            this.$eventBus.$on('residence:resize', function(_d) { setTimeout(function() { _d = (typeof _d !== 'undefined') ? _d : 600;vm.resizeResidence(); }, _d); });
            this.$eventBus.$on('exposure:animate', (name) => vm.playExposureAnimation(name));
            this.$eventBus.$on('power-surge:dimmer', vm.animateDimmers);
            this.$eventBus.$on('power-surge:end', vm.resetExposureAnimations);
            this.$eventBus.$on('points:show', vm.showPoints);
            this.$eventBus.$on('points:hide', vm.hidePoints);
            this.$eventBus.$on('points:state:reset', vm.resetPointsState);
            this.$eventBus.$on('points:state:active', (point) => vm.setPointState(point));

        },

        mounted() {
            vm = this;

            if (vm.$md.tablet()) {
                vm.residenceImage = '/static/images/MBR-055_House-Layered_Base_tablet.jpg';
                vm.scale.points.out = 2.5;
                vm.scale.wide = .20;
                vm.scale.min = .25;
            }

            vm.debug = vm.getQueryString("debug") == 1;
            vm.createResidence();

            addResizeListener(document.getElementById('base-container'), function() {
                vm.resizeResidence();
            });
        },

        methods: {

            getQueryString(key, default_) {
                if (default_ == null) { default_ = ""; }
                key = key.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
                let regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
                let qs = regex.exec(window.location.href);
                if (qs == null) { return default_; } else { return qs[1]; }
            },

            /**
             * @method createResidence
             * @description Create PIXI Application Scene.
             */
            createResidence() {

                let _container   = document.getElementById('base-container'),
                    _width       = _container.clientWidth,
                    _height      = _container.clientHeight,
                    _forceCanvas = !!vm.$md.tablet();

                // override the width & height on tablet, due to clientHeight not being available in time on older devices
                if(vm.$md.tablet()) {
                    if (typeof(document.compatMode) == 'undefined' || document.compatMode == 'CSS1Compat') {
                        _width = document.documentElement.clientWidth;
                        _height = document.documentElement.clientHeight - document.querySelector('footer').clientHeight;
                    }
                }

                vm.pixiApp = new PIXI.Application({
                    width:          _width,
                    height:         _height,
                    transparent:    false,
                    antialias:      true,
                    resolution:     1,
                    forceCanvas:    _forceCanvas,
                    autoResize:     true,
                    roundPixels:    true,
                    legacy:         true
                });

                vm.pixiApp.renderer.backgroundColor = 0xCBCBCB;

                window.pixiApp = vm.pixiApp;

                _container.appendChild(vm.pixiApp.view);

                vm.graphicLayer = new PIXI.display.Group(5, true);
                vm.animationLayer = new PIXI.display.Group(10, true);
                vm.highlightLayer = new PIXI.display.Group(15, true);
                vm.dimLayer = new PIXI.display.Group(19, true);
                vm.pointLayer = new PIXI.display.Group(20, true);

                vm.pixiApp.stage = new PIXI.display.Stage();
                vm.pixiApp.stage.group.enableSort = true;
                vm.pixiApp.stage._name = 'stage';

                vm.pixiApp.stage.addChild(new PIXI.display.Layer(vm.graphicLayer));
                vm.pixiApp.stage.addChild(new PIXI.display.Layer(vm.animationLayer));
                vm.pixiApp.stage.addChild(new PIXI.display.Layer(vm.highlightLayer));
                vm.pixiApp.stage.addChild(new PIXI.display.Layer(vm.dimLayer));
                vm.pixiApp.stage.addChild(new PIXI.display.Layer(vm.pointLayer));

                vm.offset = {x:0, y:0};  //{x:77, y:91}
                vm.pointsOffset = {x:0, y:0};

                PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;

                vm.pixiApp.renderer.render(vm.pixiApp.stage);

                PIXI.loader
                    .add('_residence', vm.residenceImage)
                    .load(setup);

                function setup() {
                    let _container  = document.getElementById('base-container'),
                        _width      = _container.clientWidth,
                        _height     = _container.clientHeight;

                    // vm.residence = new PIXI.Sprite(PIXI.loader.resources['_residence'].texture);
                    let origTex = new PIXI.RenderTexture.create(vm.target.width, vm.target.height);
                    vm.residence = new PIXI.Sprite(origTex);
                    vm.residence._name = 'residence';
                    vm.residence.alpha = 0;
                    vm.residence.interactive = true;
                    vm.residence.buttonMode = true;
                    vm.residence.cursor = 'move';
                    vm.residence.scale.x = vm.scale.initial;
                    vm.residence.scale.y = vm.scale.initial;
                    vm.residence.anchor.x = 0.5;
                    vm.residence.anchor.y = 0.5;
                    vm.residence.x = (_width * .5);
                    vm.residence.y = (_height * .5);
                    vm.residence.zOrder = 1;

                    vm.residence
                        .on('pointerdown', onDragStart)
                        .on('pointerup', onDragEnd)
                        .on('pointerupoutside', onDragEnd)
                        .on('pointermove', onDragMove);

                    // add the house texture to an inner sprite, so we can scale it independently
                    vm.residenceInner = new PIXI.Sprite(PIXI.loader.resources['_residence'].texture);
                    vm.residenceInner.anchor.x = 0.5;
                    vm.residenceInner.anchor.y = 0.5;
                    vm.residenceInner.width = 5933;
                    vm.residenceInner.height = 3671;
                    vm.residence.addChild(vm.residenceInner);

                    vm.pixiApp.stage.addChild(vm.residence);

                    TweenMax.to(vm.residence, 1.2, {
                        alpha: 1,
                        ease: Quad.easeInOut
                    });

                    vm.addExposureImages();

                    vm.pixiApp.ticker.add(update);

                    // vm.hammer = new Hammer(_container);
                    // vm.hammer.get('pinch').set({ enable: true });

                    if(vm.$md.tablet()){
                        vm.hammerManager = new Hammer.Manager(_container);
                        vm.hammerManager.add( new Hammer.Pinch() );
                        vm.hammerManager.on("pinchout", onPinchIn);
                        vm.hammerManager.on("pinchin", onPinchOut);
                        vm.isPinching = false;
                    }
                }

                function onPinchIn(evt){
                    if(vm.isPinching)
                        return;

                    vm.isPinching = true;
                    setTimeout(function(){
                        vm.isPinching = false;
                    }, 1500);

                    // vm.zoomIn();
                    vm.$eventBus.$emit('residence:zoomin');

                }

                function onPinchOut(evt){
                    if(vm.isPinching)
                        return;

                    vm.isPinching = true;
                    setTimeout(function(){
                        vm.isPinching = false;
                    }, 1500);

                    // vm.zoomOut();
                    vm.$eventBus.$emit('residence:zoomout');
                    vm.$eventBus.$emit('panel:close');
                }

                /**
                 * Update loop
                 */
                function update() {

                    let _container  = document.getElementById('base-container'),
                        _width      = _container.clientWidth,
                        _height     = _container.clientHeight;

                    // keep everything in bounds
                    if (vm.residence.getBounds().width < _width) {
                        TweenMax.killTweensOf(vm.residence, {x:true, y:true});
                        vm.residence.width = _width;
                        vm.residence.scale.y = vm.residence.width / vm.residence.getLocalBounds().width;
                        vm.residence.x = _width* .5;
                    } else if (vm.residence.getBounds().height < _height) {
                        TweenMax.killTweensOf(vm.residence, {x:true, y:true});
                        vm.residence.height = _height;
                        vm.residence.scale.x = vm.residence.height / vm.residence.getLocalBounds().height;
                        vm.residence.y = _height* .5;
                    }

                    // moved rimJob code here so we are doing all constraining in one place
                    let _minX = (vm.residence.width / 2),
                        _minY = (vm.residence.height / 2) - vm.offset.y,
                        _maxX = (vm.pixiApp.renderer.width - (vm.residence.width / 2)) - vm.offset.x,
                        _maxY = vm.pixiApp.renderer.height - (vm.residence.height / 2);

                    vm.residence.position.x = vm.clamp(vm.residence.position.x, _minX, _maxX);
                    vm.residence.position.y = vm.clamp(vm.residence.position.y, _minY, _maxY);

                }

                function onDragStart(evt) {
                    this.data = evt.data;
                    this.dragging = this.data.getLocalPosition(this.parent);
                    // interrupt pulse animations
                    vm.lastInteraction = vm.timeStampMs();
                }

                function onDragEnd() {
                    this.dragging = false;
                    this.data = null;
                    // interrupt pulse animations
                    vm.lastInteraction = vm.timeStampMs();
                }

                function onDragMove() {
                    if (this.dragging) {
                        let newPos = this.data.getLocalPosition(this.parent);

                        this.position.x += (newPos.x - this.dragging.x);
                        this.position.y += (newPos.y - this.dragging.y);

                        let _minX = (vm.residence.width / 2),
                            _minY = (vm.residence.height / 2) - vm.offset.y,
                            _maxX = (vm.pixiApp.renderer.width - (vm.residence.width / 2)) + vm.offset.x,
                            _maxY = vm.pixiApp.renderer.height - (vm.residence.height / 2);

                        this.position.x = vm.clamp(this.position.x, _minX, _maxX);
                        this.position.y = vm.clamp(this.position.y, _minY, _maxY);

                        this.dragging = newPos;

                        // interrupt pulse animations
                        vm.lastInteraction = vm.timeStampMs();
                    }
                }

                let debouncedResize = _.debounce(vm.resizeResidence, 30);
                window.addEventListener('resize', debouncedResize, false);
                window.addEventListener('deviceOrientation', debouncedResize, false);

                vm.resizeResidence();

            },

            /**
             * @method createExposurePoints
             * @description
             */
            createExposurePoints() {

                let _primaryColor   = vm.getCSSColorVariable('--color-primary-rgb'),
                    _secondaryColor = vm.getCSSColorVariable('--color-secondary-rgb');

                _primaryColor = _primaryColor.split("(")[1].split(")")[0];
                _secondaryColor = _secondaryColor.split("(")[1].split(")")[0];

                _primaryColor   = _primaryColor.split(',');
                _secondaryColor = _secondaryColor.split(',');

                let _primaryColorX = _primaryColor.map(function(x) {
                    x = parseInt(x).toString(16);
                    return (x.length == 1) ? '0' + x : x;
                });
                _primaryColorX = '0x' + _primaryColorX.join('');

                let _secondaryColorX = _secondaryColor.map(function(x) {
                    x = parseInt(x).toString(16);
                    return (x.length == 1) ? '0' + x : x;
                });
                _secondaryColorX = '0x' + _secondaryColorX.join('');

                //console.log('_primaryColorX', _primaryColorX);
                //console.log('_secondaryColorX', _secondaryColorX);

                let _d = (vm.$md.tablet()) ? 8 : 16,
                    _rd = (vm.$md.tablet()) ? 2 : 4;

                // circles
                let _circleUp = new PIXI.Graphics();
                    _circleUp.beginFill(0xFFFFFF);
                    _circleUp.lineStyle(_rd, _primaryColorX);
                    _circleUp.drawCircle(_d, _d, _d);
                    _circleUp.endFill();

                let _circleUpTexture = _circleUp.generateCanvasTexture();

                let _circleOver = new PIXI.Graphics();
                    _circleOver.beginFill(0xFFFFFF);
                    _circleOver.lineStyle(_rd, _secondaryColorX);
                    _circleOver.drawCircle(_d, _d, _d);
                    _circleOver.endFill();

                let _circleOverTexture = _circleOver.generateCanvasTexture();

                // dropshadow filter
                let _shadow = new filters.DropShadowFilter();
                    _shadow.blur = 5;
                    _shadow.alpha = 0.36;
                    _shadow.distance = 0;

                let _zoomed = this.$dataStore.getters.getZoomedState;

                // loop through all exposures and place circle
                _.each(vm.exposures, function(val, key) {

                    let _s = new PIXI.Sprite(_circleUpTexture);

                    _s._data = val;
                    _s._interacted = false;
                    _s._name = val.exposure_name;
                    _s._slug = val.exposure_slug;
                    _s._active = false;
                    _s.interactive = true;
                    _s.buttonMode = true;
                    _s.cursor = 'pointer';
                    _s.alpha = 0;
                    _s.zOrder = 999;
                    _s.position.x = val.x + vm.pointsOffset.x;
                    _s.position.y = val.y + vm.pointsOffset.y;
                    _s.scale.x = 1;
                    _s.scale.y = 1;
                    _s.anchor.x = 0.5;
                    _s.anchor.y = 0.5;
                    _s.parentGroup = vm.pointLayer;

                    // add shadows to exposurepPoints if using WEBGL and not tablet
                    if (PIXI.RENDERER_TYPE.WEBGL == vm.pixiApp.renderer.type && !vm.$md.tablet()) {
                        _s.filters = [_shadow]; /* WebGL only... */
                    }

                    _s.on('pointerup', function(evt) {

                        let _this   = this,
                            /*_panel  = (_this._data.coverage) ? 'panel-content-coverages' : 'panel-content-exposure',*/
                            _panel  = 'panel-content-exposure',
                            _service = (_this._data.exposure_type === 'service-line'),
                            _premise = (_this._data.exposure_type === 'off-premise');

                        gtag('event', 'Equipment Selection', {
                            'event_category': 'MBRe: Residential',
                            'event_label': _this._name
                        });

                        // set interacted flag
                        _this._interacted = true;
                        vm.pulseClicked = true;

                        // reset/set active states
                        vm.resetPointsState();

                        setTimeout(function() {
                            _this._active = true;
                            _this.texture = _circleOverTexture;
                        }, 10);

                        // toggle panel
                        vm.togglePanel(_panel, _this._slug, _service, _premise);

                        // zoom to point
                        vm.zoomTo(1, 1, 1, Quad.easeInOut, evt, _this);

                        if (vm.debug) {
                            setTimeout(function() {
                                vm.playExposureAnimation(_this._slug);
                            }, 1000);
                        }

                    });

                    _s.on('pointerover', function(evt) {
                        let _this = this;
                        _this.texture = _circleOverTexture;
                    });

                    _s.on('pointerout', function(evt) {
                        let _this = this;
                        if (_this._active) {
                            _this.texture = _circleOverTexture;
                        } else {
                            _this.texture = _circleUpTexture;
                        }
                    });

                    vm.residence.addChild(_s);

                    vm.exposureObjects[val.exposure_slug] = _s;

                    if (val.enabled && val.animation.enabled) {
                        // name, json, frame, x, y
                        vm.createExposureAnimations(val.exposure_slug, val.animation.json, val.animation.name, val.animation.x, val.animation.y, val.animation.frames, val.animation.loop);
                    }
                });

                // emit ready
                vm.$eventBus.$emit('loading:ready');

            },

            /**
             * @method showPoints
             * @description
             */
            showPoints() {

                _.each(vm.exposureObjects, function(val) {
                    TweenMax.to(val, 0.2, { alpha: 1 });
                });

                vm.startPulseAnimations();

            },

            /**
             * @method hidePoints
             * @description
             */
            hidePoints() {

                vm.stopPulseAnimations();

                TweenMax.set(vm.highlightObjects, { alpha: 0 });

                _.each(vm.exposureObjects, function(val) {
                    TweenMax.to(val, 0.2, { alpha: 0 });
                });

            },

            setPointState(point) {
                console.log('setPointState', point);
                let _primaryColor   = vm.getCSSColorVariable('--color-primary-rgb'),
                    _secondaryColor = vm.getCSSColorVariable('--color-secondary-rgb');

                _primaryColor = _primaryColor.split("(")[1].split(")")[0];
                _secondaryColor = _secondaryColor.split("(")[1].split(")")[0];

                _primaryColor   = _primaryColor.split(',');
                _secondaryColor = _secondaryColor.split(',');

                let _primaryColorX = _primaryColor.map(function(x) {
                    x = parseInt(x).toString(16);
                    return (x.length == 1) ? '0' + x : x;
                });
                _primaryColorX = '0x' + _primaryColorX.join('');

                let _secondaryColorX = _secondaryColor.map(function(x) {
                    x = parseInt(x).toString(16);
                    return (x.length == 1) ? '0' + x : x;
                });
                _secondaryColorX = '0x' + _secondaryColorX.join('');

                console.log('_primaryColorX', _primaryColorX);
                console.log('_secondaryColorX', _secondaryColorX);

                let _d = (vm.$md.tablet()) ? 8 : 16,
                    _rd = (vm.$md.tablet()) ? 2 : 4;

                let _circleOver = new PIXI.Graphics();
                _circleOver.beginFill(0xFFFFFF);
                _circleOver.lineStyle(_rd, _secondaryColorX);
                _circleOver.drawCircle(_d, _d, _d);
                _circleOver.endFill();

                let _circleOverTexture = _circleOver.generateCanvasTexture();


                vm.exposureObjects[point]._active = true;
                vm.exposureObjects[point].texture = _circleOverTexture;
            },

            /**
             * @method resetPointsState
             * @description
             */
            resetPointsState() {

                let _primaryColor   = vm.getCSSColorVariable('--color-primary-rgb'),
                    _secondaryColor = vm.getCSSColorVariable('--color-secondary-rgb');

                _primaryColor = _primaryColor.split("(")[1].split(")")[0];
                _secondaryColor = _secondaryColor.split("(")[1].split(")")[0];

                _primaryColor   = _primaryColor.split(',');
                _secondaryColor = _secondaryColor.split(',');

                let _primaryColorX = _primaryColor.map(function(x) {
                    x = parseInt(x).toString(16);
                    return (x.length == 1) ? '0' + x : x;
                });
                _primaryColorX = '0x' + _primaryColorX.join('');

                let _secondaryColorX = _secondaryColor.map(function(x) {
                    x = parseInt(x).toString(16);
                    return (x.length == 1) ? '0' + x : x;
                });
                _secondaryColorX = '0x' + _secondaryColorX.join('');

                console.log('_primaryColorX', _primaryColorX);
                console.log('_secondaryColorX', _secondaryColorX);

                let _d = (vm.$md.tablet()) ? 8 : 16,
                    _rd = (vm.$md.tablet()) ? 2 : 4;

                let _circleUp = new PIXI.Graphics();
                    _circleUp.nativeLines = true;
                    _circleUp.beginFill(0xFFFFFF);
                    _circleUp.lineStyle(_rd, _primaryColorX);
                    _circleUp.drawCircle(_d, _d, _d);
                    _circleUp.endFill();

                let _circleUpTexture = _circleUp.generateCanvasTexture();

                _.each(vm.exposureObjects, function(val) {
                    val._active = false;
                    val.texture = _circleUpTexture;
                });
            },

            /**
             * @method scaleExposurePoints
             * @description
             */
            scaleExposurePoints() {

                let _zoomed = this.$dataStore.getters.getZoomedState;

                _.each(vm.exposureObjects, function(val, key) {
                    let tl = new TimelineMax({
                        onUpdateScope: vm.pixiApp.stage
                    });

                    tl.to(val.scale, 0.3, {
                        x: (_zoomed) ? vm.scale.points.in : vm.scale.points.out,
                        y: (_zoomed) ? vm.scale.points.in : vm.scale.points.out,
                        ease: Quad.easeInOut
                    });
                });

            },

            /**
             * @method animateExposurePoints
             * @description
             */
            animateExposurePoints() {

                let _x = 0,
                    _zoomed = this.$dataStore.getters.getZoomedState;

                _.each(vm.exposureObjects, function(val, key) {

                    let tl = new TimelineMax({
                        onCompleteParams: [_x],
                        onComplete: function(_key) {
                            if (_key >= Object.keys(vm.exposureObjects).length - 1) {
                                // interactive transition is complete
                                vm.$dataStore.dispatch('TRANSITION_INTERACTIVE', { val: true });

                                if (!vm.$dataStore.getters.getPowerSurgeState) {
                                    // points are now in, show interaction cta
                                    vm.$eventBus.$emit('cta:show');
                                }

                                vm.createExposurePointPulse();
                            }
                        }
                    });

                    tl.to(val, 0.3, {
                        alpha: (vm.$dataStore.getters.getPowerSurgeState) ? 0 : 1,
                        ease: Back.easeOut
                    }, '-=0.3');

                    tl.to(val.scale, 0.6, {
                        x: (_zoomed) ? vm.scale.points.in : vm.scale.points.out,
                        y: (_zoomed) ? vm.scale.points.in : vm.scale.points.out,
                        ease: Back.easeOut
                    });

                    _x++;

                });

            },

            /**
             * @method createExposurePointPulse
             * @description
             */
            createExposurePointPulse() {

                let _d = (vm.$md.tablet()) ? 8 : 16;

                // circles
                let _pulse = new PIXI.Graphics();
                    _pulse.nativeLines = true;
                    _pulse.beginFill(0xFFFFFF);
                    _pulse.lineStyle(0, 0xFFFFFF);
                    _pulse.drawCircle(_d, _d, _d);
                    _pulse.endFill();

                let _pulseTexture = _pulse.generateCanvasTexture();

                // loop through all exposures and place circle
                _.each(vm.exposures, function(val, key) {

                    let _p = new PIXI.Sprite(_pulseTexture);

                    _p._name = 'pulse_' + val.exposure_slug;
                    _p._slug = val.exposure_slug;
                    _p.interactive = false;
                    _p.buttonMode = false;
                    _p.alpha = 0;
                    _p.zOrder = 1000;
                    _p.position.x = val.x + vm.pointsOffset.x;
                    _p.position.y = val.y + vm.pointsOffset.y;
                    _p.scale.x = 1;
                    _p.scale.y = 1;
                    _p.anchor.x = 0.5;
                    _p.anchor.y = 0.5;
                    _p.parentGroup = vm.highlightLayer;

                    vm.residence.addChild(_p);

                    vm.highlightObjects.push(_p);

                });

                setTimeout(function() {
                    vm.startPulseAnimations();
                }, vm.pulseIntervalDuration);

            },

            /**
             * @method animateExposurePointPulse
             * @description
             */
            animateExposurePointPulse() {

                if (this.$dataStore.getters.getPowerSurgeState) {
                    vm.pulseAnimating = false;
                    return;
                }

                vm.pulseAnimating = true;

                if (vm.pulseAll) {

                    // ALL AT ONCE
                    _.each(vm.highlightObjects, function(val, key) {

                        if (!vm.pulseClicked) {

                            vm.pulseTimeline[key] = new TimelineMax({ repeat: -1 });

                            vm.pulseTimeline[key].set(val, {
                                alpha: 1
                            });

                            vm.pulseTimeline[key].set(val.scale, {
                                x: 1,
                                y: 1
                            });

                            vm.pulseTimeline[key].to(val.scale, 1.2, {
                                x: 2,
                                y: 2,
                                ease: Quad.easeInOut,
                                delay: 0.02 * key
                            });

                            vm.pulseTimeline[key].to(val, 1.2, {
                                alpha: 0,
                                ease: Quad.easeInOut
                            }, '-=0.8');

                        }

                    });

                } else {

                    // RANDOM ONE AT A TIME
                    let _count      = vm.highlightObjects.length,
                        _randPoint  = vm.highlightObjects[_.random(0, _count - 1)];

                    if (!vm.pulseClicked) {

                        vm.pulseTimeline[0] = new TimelineMax({ repeat: 8, repeatDelay: 0.2 });

                        vm.pulseTimeline[0].set(_randPoint, {
                            alpha: 1
                        });

                        vm.pulseTimeline[0].set(_randPoint.scale, {
                            x: 1,
                            y: 1
                        });

                        vm.pulseTimeline[0].to(_randPoint.scale, 1.2, {
                            x: 1.8,
                            y: 1.8,
                            ease: Quad.easeInOut,
                            delay: 0.3
                        });

                        vm.pulseTimeline[0].to(_randPoint, 1.2, {
                            alpha: 0,
                            ease: Quad.easeInOut
                        }, '-=0.8');

                    }

                }

            },

            /**
             * @method startPulseAnimations
             * @description
             */
            startPulseAnimations() {

                // check if we've clicked a point, if so kill
                if (vm.pulseClicked) {
                    if (vm.pulseAnimating) { vm.stopPulseAnimations(); }
                    if (vm.pulseInterval) { clearInterval(vm.pulseInterval); }
                    return;
                }

                vm.pulseInterval = setInterval(function() {

                    if (vm.lastInteraction <= (vm.timeStampMs() - vm.pulseIntervalDuration)) {
                        if ((!vm.pulseAnimating && vm.pulseAll) || !vm.pulseAll) {
                            vm.animateExposurePointPulse();
                        }
                    } else {
                        vm.stopPulseAnimations();
                    }

                }, vm.pulseIntervalDuration);

            },

            /**
             * @method stopPulseAnimations
             * @description
             */
            stopPulseAnimations() {

                vm.pulseAnimating = false;

                if (vm.pulseAll) {
                    _.each(vm.pulseTimeline, function(val, key) {
                        if (!val) { return; }
                        val.seek(0).stop();
                    });
                } else {
                    vm.pulseTimeline[0].stop();
                }

                vm.pulseTimeline = [];
            },

            /**
             * @method addExposureImages
             * @description
             */
            addExposureImages() {

                _.each(vm.exposures, function(val, key) {

                    if (val.enabled === false || val.graphic === null) {
                        return;
                    }

                    let _name = val.exposure_slug + '_exposure';

                    if (_.isNil(vm.exposureImageObjects[_name])) {
                        PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;
                        // texture does not exist, load it up
                        let _loader = new PIXI.loaders.Loader();
                            _loader
                                .add(_name, val.graphic.source)
                                .load(onExposureLoaded);
                    }

                    function onExposureLoaded(loader, resources) {

                        let _ex = new PIXI.Sprite(resources[_name].texture);

                        _ex._name = _name;
                        _ex.interactive = false;
                        _ex.buttonMode = false;
                        _ex.alpha = 1;
                        _ex.anchor.x = 0;
                        _ex.anchor.y = 0;
                        _ex.x = val.graphic.x + vm.pointsOffset.x;
                        _ex.y = val.graphic.y + vm.pointsOffset.y;
                        _ex.parentGroup = vm.graphicLayer;

                        vm.residence.addChild(_ex);

                        vm.exposureImageObjects[_name] = _ex;
                    }

                });

                vm.createExposurePoints();
                vm.createRoomDimmers();
            },

            debugExposureImages(){
                //console.log("debugExposureImages");

                // animationObjects
                _.each(vm.animationObjects, function(item, key) {

                    item.interactive = true;
                    item.on('pointerdown', function(event) {
                        window.moveItem = item;
                    });

                });

                // exposureObjects
                _.each(vm.exposureObjects, function(item, key) {

                    item.interactive = true;
                    item.on('pointerdown', function(event) {
                        window.moveItem = item;
                    });

                });

                // exposureImageObjects
                _.each(vm.exposureImageObjects, function(item, key) {
                    item.interactive = true;
                    item.on('pointerdown', function(event) {
                        window.moveItem = item;
                    });

                });

                document.addEventListener('keydown', function(key){

                    let moveAmount = 1;
                    let isShift = !!key.shiftKey;

                    if (isShift) {
                        moveAmount = 10;
                    }

                    switch(key.keyCode) {
                        // UP
                        case 38:
                            window.moveItem.y-=moveAmount;
                            break;

                        // DOWN
                        case 40:
                            window.moveItem.y+=moveAmount;
                            break;

                        // LEFT
                        case 37:
                            window.moveItem.x-=moveAmount;
                            break;

                        // RIGHT
                        case 39:
                            window.moveItem.x+=moveAmount;
                            break;
                    }
                    //console.log('"x": ' + window.moveItem.x + ', ' + '"y": ' + window.moveItem.y + ',');
                });
            },

            /**
             * @method createExposureAnimations
             * @description
             * @param {String} name
             * @param {String} json
             * @param {String} frame
             * @param {Number} x
             * @param {Number} y
             * @param {Number} frames
             * @param {Boolean} loop
             */
            createExposureAnimations(name, json, frame, x, y, frames, loop) {
                //console.log('createExposureAnimations', name, json, frame, x, y, frames, loop);

                if (_.isNil(vm.animationObjects[name])) {
                    PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;
                    // texture does not exist, load it up
                    let _loader = new PIXI.loaders.Loader();
                        _loader
                            .add(name, json)
                            .load(onAnimationLoaded);
                } else {
                    // texture exists, play dat ish
                    vm.animationObjects[name].gotoAndPlay(1);
                }

                function onAnimationLoaded(loader, resources) {

                    let _frames = [];

                    for (let i = 0; i < frames; i++) {
                        let _val = i < 10 ? '0' + i : i;
                        _frames.push(PIXI.Texture.fromFrame(frame + _val + '.png'));
                    }

                    let _animation  = new PIXI.extras.AnimatedSprite(_frames),
                        _inc        = 1;

                    _animation.x = x + vm.pointsOffset.x;
                    _animation.y = y + vm.pointsOffset.y;
                    _animation.anchor.set(0);
                    _animation.parentGroup = vm.animationLayer;
                    _animation.loop = loop;
                    _animation.alpha = 0;
                    _animation.animationSpeed = 0.26;
                    _animation.gotoAndStop(1);

                    _animation.onComplete = function() {
                        if (name === vm.$dataStore.getters.getLastExposure) {
                            console.log(name, vm.$dataStore.getters.getLastExposure);
                            vm.$eventBus.$emit('powersurge:complete');
                        }
                    };

                    _animation.onLoop = function() {
                        if (_inc === vm.exposureObjects[name]._data.animation.loopDuration) {
                            this.gotoAndStop(vm.exposureObjects[name]._data.animation.frames - 1);
                            if (name === vm.$dataStore.getters.getLastExposure) {
                                setTimeout(function() {
                                    vm.$eventBus.$emit('powersurge:complete');
                                }, 2000);
                            }
                            _inc = 1;
                        } else {
                            _inc++;
                        }
                    };

                    vm.residence.addChild(_animation);

                    vm.animationObjects[name] = _animation;
                }

            },

            /**
             * @method createRoomDimmers
             * @description
             */
            createRoomDimmers() {

                _.each(vm.rooms, function(val, key) {
                    // dimmer
                    let _dimmer = new PIXI.Graphics();
                    _dimmer.nativeLines = true;
                    _dimmer.lineStyle(0, 0x000000, 0);
                    _dimmer.beginFill(0x000000, 0.70);
                    _dimmer.drawRect(val.x, val.y, val.width, val.height);
                    _dimmer.endFill();
                    _dimmer.blendMode = PIXI.BLEND_MODES.MULTIPLY;

                    let _dimmerTexture = _dimmer.generateCanvasTexture();

                    let _o = new PIXI.Sprite(_dimmerTexture);

                    _o._name = val.name;
                    _o.interactive = false;
                    _o.buttonMode = false;
                    _o.cursor = 'pointer';
                    _o.alpha = 0;
                    _o.zOrder = 1000;
                    _o.position.x = val.x /*+ vm.pointsOffset.x*/;
                    _o.position.y = val.y /*+ vm.pointsOffset.y*/;
                    _o.scale.x = 1;
                    _o.scale.y = 1;
                    _o.anchor.x = 0.5;
                    _o.anchor.y = 0.5;
                    _o.parentGroup = vm.dimLayer;

                    vm.residence.addChild(_o);
                    vm.dimmerObjects.push(_o);
                });

            },

            /**
             * @method animateDimmers
             * @description
             */
            animateDimmers() {

                let tl = new TimelineMax({
                    paused: true,
                    delay: 0.5,
                    onUpdate: function() {
                        vm.pixiApp.renderer.render(vm.pixiApp.stage);
                    }
                });

                tl.add( TweenMax.to(vm.dimmerObjects, 0.3, { alpha: 1, ease: Quad.easeInOut }) );
                tl.add( TweenMax.to(vm.dimmerObjects, 0.1, { alpha: 0.2, ease: Quad.easeInOut }) );
                tl.add( TweenMax.to(vm.dimmerObjects, 0.3, { alpha: 1, ease: Quad.easeInOut }) );
                tl.add( TweenMax.to(vm.dimmerObjects, 0.2, { alpha: 0, ease: Quad.easeInOut }) );

                tl.play();
            },

            /**
             * @method playExposureAnimation
             * @description
             * @param {String} name
             */
            playExposureAnimation(name) {
                vm.animationObjects[name].alpha = 1;
                vm.animationObjects[name].gotoAndPlay(1);

                if (name === 'electrical-service-panel') {
                    this.$eventBus.$emit('power-surge:dimmer');
                }

            },

            /**
             * @method resetExposureAnimations
             * @description
             */
            resetExposureAnimations() {
                _.each(vm.animationObjects, function(val, key) {
                    val.alpha = 0;
                    val.gotoAndStop(1);
                });
            },

            /**
             * @method resizeResidence
             * @description
             */
            resizeResidence() {
                //console.log('resizeResidence');

                setTimeout(function() {
                    let _container  = $('#base-container'),
                        _width      = _container.width(),
                        _height     = _container.height(),
                        _fHeight    = $('footer').height();

                    if (vm.residence) {
                        let _tl = new TimelineMax({ paused: true });
                        _tl.add(TweenMax.to(vm.residence, 0.6, { x: _width * .5, ease: Quad.easeInOut }));
                        _tl.add(TweenMax.to(vm.residence, 0.6, { y: _height * .5, ease: Quad.easeInOut }), '-=0.6');
                        _tl.play();
                    }

                    vm.pixiApp.renderer.resize(_width, _height);

                    vm.pixiApp.renderer.render(vm.pixiApp.stage);

                }, 50);

            },

            /**
             * @method zoomIn
             * @description
             * @param {Number} duration
             * @param {Number} sx
             * @param {Number} sy
             * @param {*} easing
             */
            zoomIn(duration, sx, sy, easing) {

                let _duration = duration ? duration : vm.scale.duration.in,
                    _sx = sx ? sx : vm.scale.max,
                    _sy = sy ? sy : vm.scale.max,
                    _easing = easing ? easing : Quad.easeInOut,
                    tl = new TimelineMax({
                        // onUpdate: vm.rimJob,
                        // onUpdateScope: vm.pixiApp.stage,
                        onStart: function(){
                            if (vm.$dataStore.state.interactive.transitioned) {
                                //vm.scaleExposurePoints();
                            }
                        },
                        onComplete: function() {
                            vm.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: true });
                        }
                    });

                // scale residence
                tl.to(vm.residence.scale, _duration, {
                    x: _sx,
                    y: _sy,
                    ease: _easing
                }, 0);

                // position residence
                tl.to(vm.residence.position, _duration, {
                    x: ((vm.pixiApp.renderer.width / 2) - vm.zoomInOffset.x), /* include panel width in x position calc */
                    y: (vm.pixiApp.renderer.height / 2) - vm.zoomInOffset.y,
                    ease: _easing
                }, 0);

            },

            /**
             * @method zoomOut
             * @description
             * @param {Number} duration
             * @param {Number} sx
             * @param {Number} sy
             * @param {*} easing
             */
            zoomOut(duration, sx, sy, easing) {

                let _duration = duration ? duration : vm.scale.duration.out,
                    _sx = sx ? sx : vm.scale.min,
                    _sy = sy ? sy : vm.scale.min,
                    _easing = easing ? easing : Quad.easeInOut,
                    tl = new TimelineMax({
                        // onUpdate: vm.rimJob,
                        // onUpdateScope: vm.pixiApp.stage,
                        onComplete: function() {
                            vm.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: false });

                            if (vm.$dataStore.state.interactive.transitioned) {
                                //vm.scaleExposurePoints();
                            }
                        }
                    });

                // scale residence
                tl.to(vm.residence.scale, _duration, {
                    x: _sx,
                    y: _sy,
                    ease: _easing
                },0);


                // scale residence
                tl.to(vm.residence, _duration, {
                    x: vm.pixiApp.renderer.width / 2,
                    y: vm.pixiApp.renderer.height / 2,
                    ease: _easing
                },0);

            },

            /**
             * @method zoomTo
             * @description
             * @param {Number} duration
             * @param {Number} sx
             * @param {Number} sy
             * @param {*} easing
             * @param {Object} evt
             * @param {Object} obj
             */
            zoomTo(duration, sx, sy, easing, evt, obj) {
                //console.log('zoomTo', duration, sx, sy, easing, evt, obj);

                let _duration = duration ? duration : 1,
                    _sx = sx ? sx : vm.scale.min,
                    _sy = sy ? sy : vm.scale.min,
                    _easing = easing ? easing : Quad.easeInOut,
                    /*_pos = evt.data.getLocalPosition(vm.pixiApp.stage),*/
                    tl = new TimelineMax({
                        // onUpdate: vm.rimJob,
                        // onUpdateScope: vm.pixiApp.stage,
                        onStart: function(){
                            if (vm.$dataStore.state.interactive.transitioned) {
                                //vm.scaleExposurePoints();
                            }
                        },
                        onComplete: function() {
                            setTimeout(function() {
                                if (name) {
                                    //vm.playExposureAnimation(obj.slug);
                                }
                            }, 600);
                        }
                    });

                // set pan duration, if we need to zoom in we then use '-='. If not, we use the full duration needed to tween.
                let panDuration = _duration;

                // zoom into residence if we are not already
                if (!this.$dataStore.state.interactive.zoomed) {
                    panDuration = '-=' + _duration;

                    this.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: true });

                    tl.to(vm.residence.scale, _duration, {
                        x: _sx,
                        y: _sy,
                        ease: _easing
                    });
                }

                // position residence, try to center to interactive point
                tl.to(vm.residence.position, _duration, {
                    x: ((vm.pixiApp.renderer.width / 2) - obj.position.x) - (375/2), /* include panel width in x position calc */
                    y: (vm.pixiApp.renderer.height / 2) - obj.position.y,
                    ease: _easing
                }, 0);

            },

            /**
             * @method transitionIn
             * @description
             */
            transitionIn(duration, sx, sy, easing) {

                let _duration = duration ? duration : vm.scale.duration.out,
                    _sx = sx ? sx : 0.20,
                    _sy = sy ? sy : 0.20,
                    _easing = easing ? easing : Quad.easeInOut,
                    tl = new TimelineMax({
                        onComplete: function() {
                            vm.animateExposurePoints();

                            if (vm.debug) {
                                vm.debugExposureImages();
                            }
                        }
                    });

                // scale residence out to single zoom
                tl.to(vm.residence.scale, _duration, {
                    x: vm.scale.wide,
                    y: vm.scale.wide,
                    ease: _easing
                }, 0);

                // scale residence out to single zoom
                tl.to(vm.residence.scale, _duration, {
                    x: vm.scale.min,
                    y: vm.scale.min,
                    ease: _easing,
                    delay: 1.5
                });

            },

            /**
             * @method transitionOut
             * @description
             */
            transitionOut() {

                setTimeout(function() {
                    vm.zoomIn();
                }, 300);

            },

            /**
             * @method animate
             * @description
             */
            animate() {
                vm.pixiApp.renderer.render(vm.pixiApp.stage);
                requestAnimationFrame(vm.animate);
            },

            /**
             * @method clamp
             * @description
             * @param {Number} val
             * @param {Number} min
             * @param {Number} max
             * @return {Number}
             */
            clamp(val, min, max) {

                if (min > max) {
                    let tempMax = max;
                    max = min;
                    min = tempMax;
                }

                if (val < min) { return min; }
                if (val > max) { return max; }

                return val;

            },

            /**
             * @method rimJob
             * @description
             */
            // rimJob() {
                // let _minX = (vm.residence.width / 2),
                //     _minY = (vm.residence.height / 2) - vm.offset.y,
                //     _maxX = (vm.pixiApp.renderer.width - (vm.residence.width / 2)) - vm.offset.x,
                //     _maxY = vm.pixiApp.renderer.height - (vm.residence.height / 2);
                //
                // vm.residence.position.x = vm.clamp(vm.residence.position.x, _minX, _maxX);
                // vm.residence.position.y = vm.clamp(vm.residence.position.y, _minY, _maxY);

                // let xClamp = vm.clamp(vm.residence.position.x, _minX, _maxX);
                // let yClamp = vm.clamp(vm.residence.position.y, _minY, _maxY);
                // TweenMax.to(vm.residence, .5, { x:xClamp, y:yClamp });
            // },

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             * @param {String} slug
             * @param {String} service
             * @param {String} premise
             */
            togglePanel(type, slug, service, premise) {
                //console.info('%ctogglePanel', 'color:orange;', type, slug, premise);

                this.$eventBus.$emit('panel:toggle', {
                    panel: type,
                    slug: slug,
                    service: service,
                    premise: premise
                });
            },

            /**
             * @method getCSSColorVariable
             * @description
             * @param color
             * @return {string}
             */
            getCSSColorVariable(color) {
                let _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

                if (!_propVal) {
                    let _color = color.replace('--', '$');
                    _propVal = window.appTheme.colors[_color];
                }

                //console.log('_propVal', _propVal);

                return _propVal;
            },

            /**
             * @method timeStampMs
             * @description
             * @return {number}
             */
            timeStampMs() {
                return window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
            },

            dec2Hex(dec) {
                dec = parseInt(dec, 10);
                if (!isNaN(dec)) {
                    hexChars = "0123456789ABCDEF";
                    if (dec > 255) {
                        return "Out of Range";
                    }
                    var i = dec % 16;
                    var j = (dec - i) / 16;
                    result = "0x";
                    result += hexChars.charAt(j) + hexChars.charAt(i);
                    return result;
                } else {
                    return NaN;
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .residence {
        width: 100%;
        height: 100%;
        position: relative;
        transition: all 1.2s $easeInOutQuad;
        backface-visibility: hidden;
        image-rendering: crisp-edges;

        &.zoomed {
            //background-position: center center;
            //background-size: 7680px 4622px;
            //transition: all 1.8s $easeInOutQuad;
        }

        & #base-container {
            line-height: 0;
            width: 100%;
            height: 100%;

            & canvas {
                display: block;
            }
        }
    }

</style>

<style lang="scss">

    .residence {

        & #base-container {

            & canvas {
                display: block;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// ResidenceInteractive.vue?d86ab384